import React, { ForwardedRef, forwardRef, useEffect, useRef } from 'react';
import useMergedRef from '@react-hook/merged-ref';
import { useFirstMountState } from 'react-use';

export interface ScrollToViewportProps {
  active: boolean;
  children: React.ReactElement | null;
  options?: boolean | ScrollIntoViewOptions;
  scrollOnMount?: boolean;
}

export const ScrollToViewport = forwardRef(function ScrollToViewport(
  { children, active, options, scrollOnMount }: ScrollToViewportProps,
  ref: ForwardedRef<HTMLElement>,
) {
  const scrollRef = useRef<HTMLElement>();
  const mergedRef = useMergedRef(ref, scrollRef);

  const hasChildren = !!children;
  const isFirstMount = useFirstMountState();

  useEffect(() => {
    if ((scrollOnMount || !isFirstMount) && active && hasChildren) {
      scrollRef.current?.scrollIntoView(
        options ?? {
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center',
        },
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active, hasChildren]);

  return (
    children &&
    React.cloneElement(children, {
      ref: mergedRef,
    })
  );
});
